/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserComponentModel { 
    id?: number;
    fullname?: string;
    isOwner?: boolean;
    phone?: string;
    owner?: boolean;
}

